<app-sidebar></app-sidebar>
<app-header></app-header>
<div class="body">
  <router-outlet></router-outlet>
  <router-outlet name="secondary"></router-outlet>
  <app-chat-bot></app-chat-bot>
</div>
<ngx-ui-loader></ngx-ui-loader>
